/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

import $ from "jquery";


function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getDiscount() {
  if (
    !getDiscountSession() ||
    getCookie("discount_code") !== getDiscountSession()
  ) {
    //(typeof sessionStorage.getItem('discount') === 'undefined' || sessionStorage.getItem('discount') === null || sessionStorage.getItem('discount') === 'FALSE') {
    var cookie = getCookie("discount_code");
    var url = '/apps/discountz-api/discount-info'
    
    if (cookie && cookie !== "") {
      return fetch(
        url,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ code: cookie, exchangeRate: window.Shopify.currency.rate || '1.0' }),
        }
      )
        .then(function (response) {
          return response.status === 200 ? response.text() : null;
        })
        .then(function (data) {
          var result = {}
          try {
            result = JSON.parse(data)
          } catch (error) {
            result.status = "NOT_ACTIVE"
          }
          if (result && result.status === "ACTIVE") {
            setCookie("discount_code", cookie, 365);
            setCookie("discount_response", true, 365);
            setDiscountSession(cookie);
            return cookie;
          } else {
            setCookie("discount_code", "", 365);
            setCookie("discount_response", false, 365);
            setDiscountSession(false);
            return false;
          }
        });
    }
  }
  return Promise.resolve(getDiscountSession());
}

function getDiscountValues() {
  return getDiscount().then(function (discount) {
    if (discount) {
      var url = '/apps/discountz-api'
   
      return $.getJSON("/cart.js").then(function (cart) {
        return $.ajax({
          url: url,
          method: "POST",
          crossDomain: true,
          dataType: "json",
          contentType: "application/json",
          data: JSON.stringify({
            customerId: customerId,
            cart: cart,
            code: discount,
          }),
        })
          .then(function (response) {
            if (response.valid) {
              response.code = discount;
              return response;
            }
            return false;
          })
          .catch(function (error) {
            console.log(error);
            return false;
          });
      });
    }
    return false;
  });
}

export async function checkGoldClubCookie() {
  let goldActive = false;
  let unixTimestampNow = Math.floor(Date.now() / 1000);
  if (!!window.theme.enableCustomerGC) {
    //check if customer tags has gold_status and get the timestamp
    if (!!window.theme.customerTags) {
      let customerTags = window.theme.customerTags
      customerTags.forEach(tag => {
        if (tag.includes("gold_status")){
          let TagTimestamp = tag.split(':')
          if (!!TagTimestamp[1]) {
            //check if customer tags timestamp is not in the past
            if (Number(TagTimestamp[1]) >= unixTimestampNow) {
              goldActive = true
            }
          }
        }
      });
    }

    //check if cart attributes has gold_status and get the timestamp
    if (!!window.theme.cartAttributes && goldActive == false ) {
      let cartAttributes = window.theme.cartAttributes
      if (cartAttributes['gc_status'] == "1") {
        //check if customer tags timestamp is not in the past
        if (Number(cartAttributes['valid_until']) >= unixTimestampNow) {
          goldActive = true
        }
      }
    }
  }
 
  
  //check if gc code is applied and if not if we have customer tag ot attribute active
  return getDiscount().then(function (cookie) {
    if (cookie && cookie.substring(0, 2).toLowerCase() === "gc") {
      return true;
    } else if (goldActive === true) {
      return true;
    }
    return false;
  });
}

function getDiscountSession() {
  var discount = sessionStorage.getItem("discount");
  if (typeof discount === "string" && discount.length && discount !== "FALSE") {
    return discount;
  }
  return false;
}

function setDiscountSession(value) {
  sessionStorage.setItem("discount", value ? value : "FALSE");
}

/**
 * Switches out product prices for gold club members
 */
function switchGoldClubPricing() {
  checkGoldClubCookie().then(function (cookie) {
    if (cookie) {
      if (!!document.querySelectorAll(".cart-toggle-price__gold-club")) {
        document.querySelectorAll(".cart-toggle-price__gold-club").forEach(function(element) {
          element.style.display = "";
        });
      }
      if (!!document.querySelectorAll(".cart-toggle-price__normal")) {
        document.querySelectorAll(".cart-toggle-price__normal").forEach(function(element) {
          element.style.display = "none";
        });
      }
      if (!!document.querySelectorAll(".cart-toggle-tag__gold_club")) {
        document.querySelectorAll(".cart-toggle-tag__gold_club").forEach(function(element) {
          element.style.display = "";
        });
      }
      if (!!document.querySelectorAll(".toggle-price__gold-club")) {
        document.querySelectorAll(".toggle-price__gold-club").forEach(function(element) {
          element.style.display = "";
        });
      }
      if (!!document.querySelectorAll(".toggle-price__normal")) {
        document.querySelectorAll(".toggle-price__normal").forEach(function(element) {
          element.style.display = "none";
        });
      }
      if (!!document.querySelectorAll(".toggle-product-lagel-savings-gold-club")) {
        document.querySelectorAll(".toggle-product-lagel-savings-gold-club").forEach(function(element) {
          element.style.display = "";
        });
      }
      if (!!document.querySelectorAll(".toggle-product-lagel-savings-normal")) {
        document.querySelectorAll(".toggle-product-lagel-savings-normal").forEach(function(element) {
          element.style.display = "none";
        });
      }
   
      if (!!document.querySelector(".line-item-table")) {
        document.querySelector(".line-item-table").classList.add("vicampo-cart__wrapper-items--gc");
      }
      
      var bottlesWrapper = document.querySelector(".cart-quantity-bottles--wrapper");
      if (!!bottlesWrapper) {
        bottlesWrapper.classList.remove("hidden");
      }
    } else {
      
      if (!!document.querySelectorAll(".cart-toggle-price__gold-club")) {
        document.querySelectorAll(".cart-toggle-price__gold-club").forEach(function(element) {
          element.style.display = "none";
        });
      }
      if (!!document.querySelectorAll(".cart-toggle-price__normal")) {
        document.querySelectorAll(".cart-toggle-price__normal").forEach(function(element) {
          element.style.display = "";
        });
      }
      if (!!document.querySelectorAll(".cart-toggle-tag__gold_club")) {
        document.querySelectorAll(".cart-toggle-tag__gold_club").forEach(function(element) {
          element.style.display = "none";
        });
      }
      if (!!document.querySelectorAll(".toggle-price__gold-club")) {
        document.querySelectorAll(".toggle-price__gold-club").forEach(function(element) {
          element.style.display = "none";
        });
      }
      if (!!document.querySelectorAll(".toggle-price__normal")) {
        document.querySelectorAll(".toggle-price__normal").forEach(function(element) {
          element.style.display = "";
        });
      }
      if (!!document.querySelectorAll(".toggle-product-lagel-savings-gold-club")) {
        document.querySelectorAll(".toggle-product-lagel-savings-gold-club").forEach(function(element) {
          element.style.display = "none";
        });
      }
      if (!!document.querySelectorAll(".toggle-product-lagel-savings-normal")) {
        document.querySelectorAll(".toggle-product-lagel-savings-normal").forEach(function(element) {
          element.style.display = "";
        });
      }
  
      if (!!document.querySelector(".line-item-table")) {
        document.querySelector(".line-item-table").classList.remove("vicampo-cart__wrapper-items--gc");
      }
      
      var bottlesWrapper = document.querySelector(".cart-quantity-bottles--wrapper");
      if (!!bottlesWrapper) {
        bottlesWrapper.classList.add("hidden");
      }
    }
  });
}

function removeGift(giftId) {
  return fetch(window.theme.localeRootUrl + "/cart/change.js", {
    body: JSON.stringify({
      id: giftId,
      quantity: 0,
    }),
    credentials: "same-origin",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
  }).then(function (response) {
    document.dispatchEvent(new Event("refresh"))
    if (response.status === 200) {
      document.dispatchEvent(new Event("show:toast"));
    }
  })
}

function checkGiftsInCart() {
  const scriptVariables = document.getElementById('cartVariables');

  if (!!!scriptVariables) {
    return
  }
  const variableJson = JSON.parse(scriptVariables.textContent);

  const giftOneCount = parseInt(variableJson.selected_gift_count_1);
  const giftTwoCount = parseInt(variableJson.selected_gift_count_2);
  const giftOneVariant = variableJson.selected_gift_tier_1.toString();
  const giftTwoVariant = variableJson.selected_gift_tier_2.toString();
  const giftTotalCount = parseInt(variableJson.total_gift_counter);
  const giftLevelOneThreshold = parseInt(variableJson.gift_level_one_threshold);
  const giftLevelTwoThreshold = parseInt(variableJson.gift_level_two_threshold);
  let cartSubtotalPrice = parseInt(variableJson.cart_subtotal_price);
  const giftOneAvailable = variableJson.gift_tier_one_reached;
  const giftTwoAvailable = variableJson.gift_tier_two_reached;
  var removeGiftOneObj = {}
  removeGiftOneObj[giftOneVariant] = 0
  var removeGiftTwoObj = {}
  removeGiftTwoObj[giftTwoVariant] = 0


  if (cartSubtotalPrice < giftLevelOneThreshold && giftTotalCount > 0 && giftOneVariant != "false") {
    removeCartItems(removeGiftOneObj)
  }
  if (cartSubtotalPrice < giftLevelTwoThreshold && giftTotalCount > 0 && giftTwoVariant != "false" ) {
    removeCartItems(removeGiftTwoObj)
  }

  // If both gifts are reached and in cart remove first
  if (window.theme.addBothGifts === false ) {
    if (giftOneAvailable == true && giftTwoAvailable == true) {
      let giftsAddedArr = []
      $.getJSON('/cart.js').then(function(cart) {
        cart.items.forEach(item=>{
          if (!!item.properties.__gift_stage_id) {
            giftsAddedArr.push(item.properties.__gift_stage_id)
          }
        })
        if (!!giftsAddedArr) {
          if (giftsAddedArr.length > 1) {
            var removeGiftsobj = {}
            removeGiftsobj[giftsAddedArr[0]]= 0
            removeCartItems(removeGiftsobj)
          }
        }
      })
    }
  }
}

function removeCartItems(obj) {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({'updates': obj})
  }).then(response => {
    return response.json();
  }).then(response => {
    document.dispatchEvent(new Event("show:toast"));
    document.dispatchEvent(new Event("refresh"))
  }).catch((error) => {
    console.error('Error:', error);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  checkGiftsInCart();
});

function recalculateUpsellGifts(cartTotal, freeShippingThreshold, shippingAmount, discountAmount) {
  var total_amount = cartTotal;
  const scriptItemVariables = document.getElementById('cartItems');
  let giftsCount = false
  let filteredArray = false
  let giftOneInCart = false
  let gifTwoInCart = false
  if (!!scriptItemVariables) {
    const variablesJson = JSON.parse(scriptItemVariables.textContent);
    giftsCount = variablesJson.cart_item
  }

  if (!!giftsCount) {
    giftsCount = giftsCount.split(',');
    filteredArray = giftsCount.filter(value => value !== '');
  }

  if (!!filteredArray) {
    filteredArray.forEach(function(gift) {
      if (gift == '0') {
        giftOneInCart = true
      }
      if (gift == '1') {
        gifTwoInCart = true
      }
    })
  }
  if (!!$(".gift-item-container")) {
    $(".gift-item-container").each(function () {
      $(this).removeClass("gift-item-container-enabled");
      $(this).addClass("gift-item-container-disabled");
      $(this).removeClass("gift-item__available");
      $(this).addClass("gift-item__not_available");
      $(this).find(".gift-item-select").prop("disabled", true);
    });
  }

  if (total_amount >= freeShippingThreshold) {
    if (!!$(".vicampo-shipping__progress-bar")) {
      $(".vicampo-shipping__progress-bar").css(
        "width","100%");
    }
    if (!!$("#progress-amount-shipping-required") && !!$("#progress-amount-shipping-required").attr('data-text-free')) {
      $("#progress-amount-shipping-required").text(
        $("#progress-amount-shipping-required").attr('data-text-free')
      );
    }
  }else {
    if (!!$(".vicampo-shipping__progress-bar")) {
      $(".vicampo-shipping__progress-bar").css(
        "width",
        (total_amount / freeShippingThreshold) * 100 + "%"
      );
    }
    if (!!$("#progress-amount-shipping-required") && !!$("#progress-amount-shipping-required").attr('data-text')) {
      $("#progress-amount-shipping-required").text(
        $("#progress-amount-shipping-required").attr('data-text').replace('$amount',convertMoney( freeShippingThreshold - total_amount))
      );
    }
  }


  if (total_amount >= gift_level_one_threshold) {
    if (!!$(".gift-item__gift_first_threshold")) {
      $(".gift-item__gift_first_threshold").each(function () {
        $(this).addClass("gift-item-container-enabled");
        $(this).removeClass("gift-item-container-disabled");
        var parent = this;
        $(this)
          .find(".gift-item-select")
          .each(function () {
            if ($(this).attr("data-gift-id") !== "") {
              $(this).prop("disabled", false);
              $(parent).addClass("gift-item__available");
            } else {
              $(parent).addClass("gift-item__not_available");
            }
          });
      });
    }
    if (!!$(".vicampo-product__progress-bar")) {
      $(".vicampo-product__progress-bar").css(
        "width",
        (total_amount / gift_level_one_threshold) * 100 + "%"
      );
    }
    if (!!$("#progress-amount-required") && !!$("#progress-amount-required").attr('data-text')) {
      $("#progress-amount-required").text(
        $("#progress-amount-required").attr('data-text')
      );
    }
  }else {
    if (!!$("#progress-amount-required") && !!$("#progress-amount-required").attr('data-text-one')) {
      $("#progress-amount-required").text(
        $("#progress-amount-required").attr('data-text-one').replace('$amount',convertMoney(gift_level_one_threshold - total_amount))
      );
    }
    if (!!$(".vicampo-product__progress-bar")) {
      $(".vicampo-product__progress-bar").css(
        "width",
        (total_amount / gift_level_one_threshold) * 100 + "%"
      );
    }
  }
  if (gift_level_two_threshold !== 0 && total_amount >= gift_level_two_threshold) {
    if (!!$(".gift-item__gift_second_threshold")) {
      $(".gift-item__gift_second_threshold").each(function () {
        $(this).addClass("gift-item-container-enabled");
        $(this).removeClass("gift-item-container-disabled");
        var parent = this;
        $(this)
          .find(".gift-item-select")
          .each(function () {
            if ($(this).attr("data-gift-id") !== "") {
              $(this).prop("disabled", false);
              $(parent).addClass("gift-item__available");
            } else {
              $(parent).addClass("gift-item__not_available");
            }
          });
      });
    }
    if (!!$(".vicampo-product__progress-bar")) {
      $(".vicampo-product__progress-bar").css("width", "100%");
      if (!!$("#progress-amount-required").attr('data-text')) {
        $("#progress-amount-required").text(
          $("#progress-amount-required").attr('data-text')
        );
      }
    }
  }else {
    if (total_amount > gift_level_one_threshold) {
      if (!!$(".vicampo-product__progress-bar") && !!giftOneInCart) {
        $(".vicampo-product__progress-bar").css("width", "100%");
        if (!!$("#progress-amount-required").attr('data-text-two')) {
          $("#progress-amount-required").text(
            $("#progress-amount-required").attr('data-text-two').replace('$amount',convertMoney(gift_level_two_threshold - total_amount))
          );
        }
      }
      if(gift_level_two_threshold == 0){
        if (!!$(".vicampo-product__progress-bar")) {
          $(".vicampo-product__progress-bar").css("width",((total_amount - gift_level_one_threshold)) * 100 + "%");
        }
      } else {
        if (!!$(".vicampo-product__progress-bar")) {
          $(".vicampo-product__progress-bar").css(
            "width",
            ((total_amount - gift_level_one_threshold) /
              (gift_level_two_threshold - gift_level_one_threshold)) *
              100 +
              "%"
          );
        }
      }
    }
  }
  if(total_amount > gift_level_one_threshold && total_amount > gift_level_two_threshold){
    if (!!$(".vicampo-product__progress-bar")) {
      $(".vicampo-product__progress-bar").css("width","100%");
    }
    if (!!giftOneInCart && !!gifTwoInCart) {
      if (!!$(".vicampo-product__progress-bar")) {
        $(".vicampo-product__progress-bar").css("width", "100%");
        if (!!$("#progress-amount-required").attr('data-text-in-cart')) {
          $("#progress-amount-required").text(
            $("#progress-amount-required").attr('data-text-in-cart')
          );
        }
      }
    }
  }
  if(total_amount > gift_level_one_threshold || total_amount > gift_level_two_threshold){
    if (!!$(".gift-reminder__container")) {
      $(".gift-reminder__container").css("display","flex");
    }
  }else {
    if (!!$(".gift-reminder__container")) {
      $(".gift-reminder__container").css("display","none");
    }
  }
  // remaining for shipping
  if (!!$("[data-remaining-shipping-text]")) {
    var shippingNoteElement = $("[data-remaining-shipping-text]");
    if ((cartTotal - shippingAmount) < freeShippingThreshold) {
      if (!!shippingNoteElement.attr("data-remaining-shipping-text")) {
        var text = shippingNoteElement.attr("data-remaining-shipping-text").replace("$amount", convertMoney(freeShippingThreshold - (cartTotal - shippingAmount)));
        shippingNoteElement.html(text);
        shippingNoteElement.css("display", "block");
    
      }
      if (!!$("#cart-modal-shipping")) {
        var shippingModalElement = $("#cart-modal-shipping").find(
          "[data-modal-original-text]"
        );
        if (!!shippingModalElement.attr("data-modal-original-text")) {
          shippingModalElement.html(
            shippingModalElement
              .attr("data-modal-original-text")
              .replace("$amount", convertMoney(freeShippingThreshold - (cartTotal - shippingAmount)))
          );
        }
      }
     
     
    } else {
      shippingNoteElement.css("display", "none");
    }
  }


  // do removal of gifts
  if (total_amount < gift_level_one_threshold) {
    $(".gift-item__gift_first_threshold").each(function () {
      if ($(this).hasClass("gift-selected")) {
        removeGift($(this).find("[data-gift-id]").attr("data-gift-id"),);
      }
    });

    if (!!$("#cart-modal-gift1")) {
      var giftModalElement = $("#cart-modal-gift1").find(
        "[data-modal-original-text]"
      );
      if (giftModalElement.length){
        if (!!giftModalElement.attr("data-modal-original-text")) {
          giftModalElement.html(
            giftModalElement
              .attr("data-modal-original-text")
              .replace(
                "$amount",
                convertMoney(gift_level_one_threshold - total_amount)
              )
          );
        }
      }
    }
  }

  if (gift_level_two_threshold !== 0 && total_amount < gift_level_two_threshold) {
    $(".gift-item__gift_second_threshold").each(function () {
      if ($(this).hasClass("gift-selected")) {
        removeGift($(this).find("[data-gift-id]").attr("data-gift-id"));
      }
    });

    if (!!$("#cart-modal-gift2")) {
      var giftModalTwoElement = $("#cart-modal-gift2").find(
        "[data-modal-original-text]"
      );
      if (giftModalTwoElement.length){
        if (!!giftModalTwoElement.attr("data-modal-original-text")) {
          giftModalTwoElement.html(
            giftModalTwoElement
              .attr("data-modal-original-text")
              .replace(
                "$amount",
                convertMoney(gift_level_two_threshold - total_amount)
              )
          );
        }
      }
    }
  }
}

function updateMiniCartDiscount() {
  // Minicart should only trigger on non-cart page
  if (window.location.pathname !== '/cart') {
    getDiscountValues().then(function (discountResponse) {
      if (discountResponse) {
        $(".mini-cart__discount-toggle").css("display", "");
        $("#mini-cart-discount-code").html(discountResponse.code);
        $("#mini-cart-discount-value").html(convertMoney(discountResponse.discount));
        var shippingElement = $("#mini-cart-shipping-value");
        var shippingThreshold = parseInt( shippingElement.data("defaultShippingThreshold"));
        var shippingCost = parseInt(shippingElement.data("defaultShippingCost"));
        if (discountResponse.subtotal < shippingThreshold) {
          shippingElement.html(convertMoney(shippingCost));
          $("#mini-cart-total-value").html(convertMoney((discountResponse.subtotal + shippingCost)));
        } else {
          $("#mini-cart-total-value").html(convertMoney(discountResponse.subtotal));
        }
        make_discounts_great_again(getCookie("discount_code"))
      } else {
        $(".mini-cart__discount-toggle").css("display", "none");
      }
    });
  }
}

function shouldShowBanner(id) {
  if (sessionStorage.getItem("banner-" + id) !== "no") {
    return true;
  }
  return false;
}

function setBannerShouldShow(id, shouldShow) {
  sessionStorage.setItem("banner-" + id, shouldShow ? "yes" : "no");
}

var closeAllPicker = function () {
  $(".js-value-picker").map(function () {
    $(".value-picker-button--border").attr("aria-expanded", "false");
    $(".value-picker").attr("aria-hidden", "true");
    return true;
  });
};

$.Modal = function (root) {
  this.root = $(root);
  this.root.find(".modal__close, .button--close").on(
    "click",
    function () {
      this.close();
    }.bind(this)
  );
};

$.Modal.prototype = {
  open: function (data) {
    if (data) {
      var _this = this;
      Object.keys(data).map(function (key) {
        _this.root.find("[data-" + key + "]").html(data[key]);
      });
    }
    this.root.addClass("modal__visible");
  },
  close: function () {
    this.root.removeClass("modal__visible");
    if (this.onClose) {
      this.onClose();
    }
  },
};

$.Scroller = function (root) {
  this.root = $(root);
  var elements = [];
  this.root.children().each(function () {
    elements.push($(this));
    $(this).remove();
  });
  this.root.css("position", "relative");
  this.containerWidth = 0;
  this.contentWidth = 0;
  this.markerId = "marker_" + this.root.prop("id");

  this.scrollLeft = function () {
    var currentPos = parseInt(this.scrollContent.css("left").replace("px", ""));
    var totalWidth = $("#" + this.markerId).position().left;
    if (totalWidth <= this.containerWidth) {
      return;
    }
    var nextPos = currentPos + this.containerWidth;
    if (nextPos > 0) {
      nextPos = 0;
      this.root.find(".prev").removeClass("enabled");
      this.enableRightScrollControl();
    }
    this.scrollContent.animate({
      left: nextPos,
    });
  };

  this.scrollRight = function () {
    var currentPos = parseInt(this.scrollContent.css("left").replace("px", ""));
    var totalWidth = $("#" + this.markerId).position().left;
    if (totalWidth <= this.containerWidth) {
      return;
    }
    var nextPos = currentPos - this.containerWidth;
    if (totalWidth - Math.abs(nextPos) < this.containerWidth) {
      nextPos = -1 * (totalWidth - this.containerWidth);
      this.root.find(".next").removeClass("enabled");
      this.root.find(".prev").addClass("enabled");
    }
    this.scrollContent.animate({
      left: nextPos,
    });
  };

  this.enableRightScrollControl = function () {
    var totalWidth = $("#" + this.markerId).position().left;
    if (totalWidth > this.containerWidth) {
      this.root.find(".next").addClass("enabled");
    }
  };

  function applyChildren() {
    this.root.children().remove();
    this.root.css("width", "auto");
    this.containerWidth = $(root).parent().width();
    // $(root).css('width', this.containerWidth + 'px')
    // console.log(this.containerWidth)
    // $(root).css('overflow','auto')

    this.inner = $('<div class="scroll-inner">');
    this.inner.css("height", "100%");
    this.inner.css("width", "100%");
    this.root.append(this.inner);

    this.scrollContent = $('<div class="scroll-content">');
    this.scrollContent.css("display", "flex");
    this.scrollContent.css("position", "relative");
    this.scrollContent.css("background-color", "rgba(0,0,0,0.1)");
    this.contentWidth = 0;
    elements.forEach(
      function (item) {
        item.css("flex-shrink", "0");
        this.scrollContent.append(item);
      }.bind(this)
    );
    var marker = $('<div id="' + this.markerId + '"></div>');
    this.scrollContent.append(marker);
    this.scrollContent.css("width", this.contentWidth + "px");
    this.inner.append(this.scrollContent);

    var next = $(
      '<div class="scroller-next-prev next"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></div>'
    );
    next.css("position", "absolute");
    next.css("right", "-15px");
    next.css("top", "calc(50% - 15px)");
    next.on("click", this.scrollRight.bind(this));
    this.inner.append(next);

    var prev = $(
      '<div class="scroller-next-prev prev"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></div>'
    );
    prev.css("position", "absolute");
    prev.css("left", "-15px");
    prev.css("top", "calc(50% - 15px)");
    prev.on("click", this.scrollLeft.bind(this));
    this.inner.append(prev);

    this.enableRightScrollControl();
    // attachGiftOptionEvents()
  }

  applyChildren.bind(this)();

  this.refresh = function () {
    applyChildren.bind(this)();
  };

  $(window).resize(
    function () {
      applyChildren.bind(this)();
    }.bind(this)
  );
};

$(document).ready(function () {
  var toggle = function (scope) {
    var el = $(scope).parent(".js-value-picker");
    var hidden = el.find(".value-picker").attr("aria-hidden");
    if (hidden === "true") {
      closeAllPicker();
      $(scope).on("focusout", function (event) {
        var parent = event.relatedTarget;
        if (parent != null) {
          parent = parent.parentElement.className;
          if (
            parent != "value-picker__use-selection-btn" &&
            parent != "value-picker__choice-list" &&
            parent != "value-picker__search-input"
          ) {
            $(scope).off("focusout");
            closeAllPicker();
          }
        } else {
          $(scope).off("focusout");
          closeAllPicker();
        }
      });
      el.find('[data-action="open-value-picker"]').attr(
        "aria-expanded",
        "true"
      );
      el.find(".value-picker").attr("aria-hidden", "false");
    } else {
      $(document).off(".valuePicker");
      el.find(".value-picker").attr("aria-expanded", "false");
      el.find(".value-picker").attr("aria-hidden", "true");
    }
  };
  $("#spr-mobile-btn").click(function () {
    $("html,body").animate(
      {
        scrollTop: $(".spr-form").offset().top - 170,
      },
      "slow"
    );
  });

  $(document).on(
    "click",
    '[data-action="open-vicampo-filter"][aria-controls="vicampo-second-filter"]',
    function (elem) {
      var statusFilter = $("#vicampo-second-filter").attr("aria-hidden");
      if (statusFilter == "true") {
        document
          .querySelector(
            '[data-action="open-vicampo-filter"][aria-controls="vicampo-second-filter"]'
          )
          .setAttribute("aria-expanded", "true");
        $("#vicampo-second-filter").attr("aria-hidden", "false");
      } else {
        document
          .querySelector(
            '[data-action="open-vicampo-filter"][aria-controls="vicampo-second-filter"]'
          )
          .setAttribute("aria-expanded", "false");
        $("#vicampo-second-filter").attr("aria-hidden", "true");
      }
    }
  );

  $(".spr-reviews").bind("DOMSubtreeModified", function () {
    if (
      $(".spr-rating-number").length == 0 &&
      $('meta[itemprop="ratingValue"]').attr("content")
    ) {
      $(".spr-summary")
        .children()
        .first()
        .prepend(
          '<span class="spr-rating-number">' +
            $('meta[itemprop="ratingValue"]')
              .attr("content")
              .replace(".", ",") +
            "</span>"
        );
    }
  });

  // $('.value-picker-button--border').on('click',function(){
  //   toggle(this);
  // })

  //close all picker if search
  $(".value-picker__use-selection-btn").on("click", function () {
    closeAllPicker();
  });

  $(".value-picker__search-input").keyup(function (event) {
    var inputId = event.target.id;
    var filter = document.querySelector("#" + inputId).value.toUpperCase();
    var parent = event.target.parentNode.parentNode.parentNode;
    var buttonList = parent.querySelector(".value-picker__choice-list")
      .children;
    for (var index = 0; index < buttonList.length; index++) {
      if (buttonList[index].innerText.toUpperCase().indexOf(filter) > -1) {
        buttonList[index].setAttribute("style", "display:block");
      } else {
        buttonList[index].setAttribute("style", "display:none");
      }
    }
  });

  $(".js-countdown-timer").each(function () {
    var $this = $(this);
    var id = $this.parents(".js-info-banner").data("id");

    if (!shouldShowBanner(id)) return;

    // Set the date we're counting down to
    var countDownDateStart = $this.data("date-start") ? new Date($this.data("date-start")).getTime() : null;
    var countDownDateEnd = new Date($this.data("date")).getTime();

    function shouldHideCountdown(now, startDate) {
      return startDate !== null && now <= startDate;
    }

    // Update the count down every 1 second
    var x = setInterval(function () {
      // Get today's date and time
      var now = new Date().getTime();

      // Show countdown on countDownDateStart
      if (shouldHideCountdown(now, countDownDateStart)) {
        $this.parents(".js-info-banner").addClass("hidden");
        return;
      } else {
        $this.parents(".js-info-banner").removeClass("hidden");
      }

      // Find the distance between now and the count down date
      var distance = countDownDateEnd - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Display the result in the element with id="demo"
      if (days === 0 && hours === 0 && minutes === 0) {
        $this.html(
          "<div>" + "<span>" + seconds + "</span>" +  "<span>" + (seconds == 1 ? languages.countdownSecondsLeft.one : languages.countdownSecondsLeft.other) + "</span>" + "</div> "
        );
      } else if (days === 0 && hours === 0) {
        $this.html(
          "<div>" + "<span>" + minutes + "</span>" + "<span>" + (minutes == 1 ? languages.countdownMinutesLeft.one : languages.countdownMinutesLeft.other) + "</span>" + "</div> " +
          "<div>" + "<span>" + seconds + "</span>" +  "<span>" + (seconds == 1 ? languages.countdownSecondsLeft.one : languages.countdownSecondsLeft.other) + "</span>" + "</div> "
        );
      } else if (days === 0) {
        $this.html(
          "<div>" + "<span>" + hours + "</span>" + "<span>" + (hours == 1 ? languages.countdownHoursLeft.one : languages.countdownHoursLeft.other) + "</span>" + "</div> " +
          "<div>" + "<span>" + minutes + "</span>" + "<span>" + (minutes == 1 ? languages.countdownMinutesLeft.one : languages.countdownMinutesLeft.other) + "</span>" + "</div> " +
          "<div>" + "<span>" + seconds + "</span>" + "<span>" + (seconds == 1 ? languages.countdownSecondsLeft.one : languages.countdownSecondsLeft.other) + "</span>" + "</div> "
        );
      } else {
        $this.html(
          "<div>" + "<span>" + days + "</span>" + "<span>" + (days == 1 ? languages.countdownDaysLeft.one : languages.countdownDaysLeft.other) + "</span>" +  "</div> " +
          "<div>" + "<span>" + hours + "</span>" + "<span>" + (hours == 1 ? languages.countdownHoursLeft.one : languages.countdownHoursLeft.other) + "</span>" + "</div> " +
          "<div>" + "<span>" + minutes + "</span>" + "<span>" + (minutes == 1 ? languages.countdownMinutesLeft.one : languages.countdownMinutesLeft.other) + "</span>" + "</div> " +
          "<div>" + "<span>" + seconds + "</span>" +  "<span>" + (seconds == 1 ? languages.countdownSecondsLeft.one : languages.countdownSecondsLeft.other) + "</span>" + "</div> "
        );
      }

      // If the count down is finished, write some text
      if (distance <= 0) {
        clearInterval(x);
        setBannerShouldShow(id, false);
        $this.parents(".js-info-banner").css("opacity", "0");
        $this.parents(".js-info-banner").addClass("hidden");
        $this.css("opacity", "0");
      } else {
        $this.parents(".js-info-banner").css("opacity", "1");
        $this.parents(".js-info-banner").removeClass("hidden");
      }
    }, 1000);
  });

  /**
   *
   * Notifications for discounts or marketing
   * See header.liquid
   * They use different triggers such as paramter or discount cookie
   */

  $(".js-info-banner .icon-close").on("click", function () {
    var $this = $(this);
    $this.parents(".js-info-banner").addClass("hidden");
    var id = $this.parents(".js-info-banner").data("id");
    setBannerShouldShow(id, false);
  });

  $(".js-info-banner").each(function () {
    var $this = $(this);
    var trigger = $this.data("trigger");
    var value = $this.data("value");
    var discount = getCookie("discount_code");
    var id = $this.data("id");
    if (!shouldShowBanner(id)) {
      return;
    }
    if (trigger) {
      if (trigger === "static") {
        $this.removeClass("hidden");
        setTimeout(function () {
          $this.css("opacity", "1");
        }, 1300);
      } else if (trigger === "discount-gold-club") {
        checkGoldClubCookie().then(function (discountCode) {
          if (discountCode) {
            $this.removeClass("hidden");
            setTimeout(function () {
              $this.css("opacity", "1");
            }, 1300);
          }
        });
      } else if (trigger === "discount") {
        getDiscount().then(function (discountCode) {
          if (discountCode && discountCode.substring(0, 2).toLowerCase() !== "gc" ) {
            $this.find(".text").html(
              $this
                .find(".text")
                .text()
                .replace("{{DISCOUNT}}", "<b>" + discountCode + "</b>")
            );
            $this.removeClass("hidden");
            setTimeout(function () {
              $this.css("opacity", "1");
            }, 1300);
          }
        });
      } else if (trigger === "discount-gift") {
        getDiscount().then(function (discountCode) {
          if (
            discountCode &&
            discountCode.indexOf(value) != -1
          ) {
            $this.find(".text").html(
              $this
                .find(".text")
                .text()
                .replace("{{DISCOUNT}}", "<b>" + discountCode + "</b>")
            );
            $this.removeClass("hidden");
            setTimeout(function () {
              $this.css("opacity", "1");
            }, 1300);
          }
        });
      } else if (trigger === "no-discount") {
        if (!discount && window.location.pathname === "/") {
          $this.removeClass("hidden");
          setTimeout(function () {
            $this.css("opacity", "1");
          }, 1300);
        }
      } else if (trigger === "countdown") {
        var id = $this.parents(".js-info-banner").data("id");
        if (shouldShowBanner(id)) {
          $this.removeClass("hidden");
          setTimeout(function () {
            $this.css("opacity", "1");
          }, 1300);
        }
      } else if (
        window.location.pathname === trigger ||
        window.location.search.indexOf(trigger) != -1
      ) {
        $this.removeClass("hidden");
        setTimeout(function () {
          $this.css("opacity", "1");
        }, 1300);
      }
    } else {
      $this.removeClass("hidden");
      setTimeout(function () {
        $this.css("opacity", "1");
      }, 1300);
    }
  });

  document.addEventListener(
    "theme:loading:end",
    function (e) {
      switchGoldClubPricing();
    },
    false
  );

  document.addEventListener(
    "theme:loading:start",
    function (e) {
      switchGoldClubPricing();
    },
    false
  );

  document.addEventListener("cart:rerendered", function (e) {
    switchGoldClubPricing();
    updateMiniCartDiscount();
    checkGiftsInCart();
  });

  document.addEventListener("recommendations:loaded", function (e) {
    switchGoldClubPricing();
  });

  switchGoldClubPricing();
});
function setAttrubute(active) {
  
  var data = {
    attributes: { 'gold_club_active': active }
  };

  jQuery.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function(cart) {
      document.dispatchEvent(new CustomEvent('gold:club:active'));
    },
    error: function(XMLHttpRequest, textStatus) {
      console.error('Error updating cart attributes:', textStatus);
    }
  });
}
function changeAtrributesGC() {
  checkGoldClubCookie().then(function (cookie) {
    //Set GC attribute
    fetch('/cart.js').then(response => response.json())
    .then(cart => {
      if (!!cookie) {
        if (cart.attributes['gold_club_active'] == 'false' || cart.attributes['gold_club_active'] == undefined ) {
          setAttrubute("true")
        }
      }else {
        if (cart.attributes['gold_club_active'] == 'true' || cart.attributes['gold_club_active'] == undefined ) {
          setAttrubute("false")
        }
      }
    });

    //Remove GC products
    var filteredArrGc = ''
    var scriptCartVariables = document.querySelector('#gcProducts')
    if (!!scriptCartVariables) {
      var variableCartJson = JSON.parse(scriptCartVariables.textContent);
      var simpleProductsArr = variableCartJson.gc_products
      if (!!simpleProductsArr) {
        filteredArrGc = simpleProductsArr.split(',').filter(item => item !== '' && item !== null && item !== undefined);
      }
    }
    if (cookie === false) {
      if (!!filteredArrGc) {
        filteredArrGc.forEach(function(id) {
          var removeGoldProducts = {};
          filteredArrGc.forEach(function(id) {
            removeGoldProducts[id] = 0;
          })
          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({'updates': removeGoldProducts})
          }).then(response => {
            return response.json();
          }).then(response => {
            document.dispatchEvent(new Event("show:gc:toast"));
            document.dispatchEvent(new Event("refresh"))
          }).catch((error) => {
            console.error('Error:', error);
          });
        })
      }
    }
  })
}


function fetchHeader() {
  fetch(`${window.Shopify.routes.root}?section_id=header`, {
    credentials: 'same-origin',
    method: 'GET'
  })
  .then( function(response) { 
    return response.text()
  })
  .then( function(text) {
    let newEl = document.createElement('div');
    let headerMobile = document.querySelector('.header__mobile-nav');
    let navBar = document.querySelector('.nav-bar--wrapp');
    if(!!newEl){
      newEl.innerHTML = text;
      if (!!headerMobile) {
        headerMobile.innerHTML = newEl.querySelector('.header__mobile-nav')? newEl.querySelector('.header__mobile-nav').innerHTML : '';
      }
      if (!!navBar) {
        navBar.innerHTML = newEl.querySelector('.nav-bar--wrapp') ? newEl.querySelector('.nav-bar--wrapp').innerHTML : '';
      }
      
      location.reload();
    }
  })
}

document.addEventListener("cart:rerendered", function (e) {
  changeAtrributesGC()
});
document.addEventListener("DOMContentLoaded", function (e) {
  changeAtrributesGC()
  updateMiniCartDiscount();
});
document.addEventListener("gold:club:active", function (e) {
  fetchHeader()
})
// TODO rewrite as module export
window.switchGoldClubPricing = switchGoldClubPricing
window.changeAtrributesGC = changeAtrributesGC
window.getCookie = getCookie
window.setCookie = setCookie
window.recalculateUpsellGifts = recalculateUpsellGifts
window.setDiscountSession = setDiscountSession
window.setBannerShouldShow = setBannerShouldShow
window.getDiscountSession = getDiscountSession
window.checkGoldClubCookie = checkGoldClubCookie
window.getDiscount = getDiscount